import { useResetAtom } from 'jotai/utils'
import { useUnmount } from 'react-use'

import { highlightedCellAtom } from '~/atoms/highlightedCellAtom'

import {
  dataDisplayTypeAtom,
  fiveSegmentCommentAtom,
  fiveSegmentHiddenColumnKeysAtom,
  fiveSegmentSortValueAtom,
  hiddenRowIdsAtom,
  isPendingTabulationAtom,
  isTabulationReadyAtom,
  lastTabulatedVariablesAtom,
  nineSegmentCommentAtom,
  nineSegmentHiddenColumnKeysAtom,
  nineSegmentSortValueAtom,
  savedFiveSegmentCommentAtom,
  savedNineSegmentCommentAtom,
  segmentDisplayTypeAtom,
  tabulationQueryDataAtom,
} from '../atoms'

export const useResetOnUnmount = () => {
  const resetDataDisplayType = useResetAtom(dataDisplayTypeAtom)
  const resetSegmentDisplayType = useResetAtom(segmentDisplayTypeAtom)
  const resetFiveSegmentComment = useResetAtom(fiveSegmentCommentAtom)
  const resetSavedFiveSegmentComment = useResetAtom(savedFiveSegmentCommentAtom)
  const resetFiveSegmentSortValue = useResetAtom(fiveSegmentSortValueAtom)
  const resetNineSegmentComment = useResetAtom(nineSegmentCommentAtom)
  const resetSavedNineSegmentComment = useResetAtom(savedNineSegmentCommentAtom)
  const resetNineSegmentSortValue = useResetAtom(nineSegmentSortValueAtom)
  const resetHiddenRowIds = useResetAtom(hiddenRowIdsAtom)
  const resetFiveSegmentHiddenColumnKeys = useResetAtom(
    fiveSegmentHiddenColumnKeysAtom,
  )
  const resetNineSegmentHiddenColumnKeys = useResetAtom(
    nineSegmentHiddenColumnKeysAtom,
  )
  const resetHighlightedCell = useResetAtom(highlightedCellAtom)

  const resetIsTabulationReady = useResetAtom(isTabulationReadyAtom)
  const resetIsPendingTabulation = useResetAtom(isPendingTabulationAtom)
  const resetTabulationQueryData = useResetAtom(tabulationQueryDataAtom)
  const resetLastTabulatedVariables = useResetAtom(lastTabulatedVariablesAtom)

  useUnmount(() => {
    resetDataDisplayType()
    resetSegmentDisplayType()
    resetFiveSegmentComment()
    resetSavedFiveSegmentComment()
    resetFiveSegmentSortValue()
    resetNineSegmentComment()
    resetSavedNineSegmentComment()
    resetNineSegmentSortValue()
    resetHiddenRowIds()
    resetFiveSegmentHiddenColumnKeys()
    resetNineSegmentHiddenColumnKeys()
    resetHighlightedCell()
    resetIsTabulationReady()
    resetIsPendingTabulation()
    resetTabulationQueryData()
    resetLastTabulatedVariables()
  })
}
